<template>
    <div class="evaluation-box-content">
        <div class="evaluation-bg">
            <el-breadcrumb
                separator-class="el-icon-arrow-right"
                class="breadcrumb-box"
            >
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>性格测试</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row class="evaluation-card evaluation-card-box1">
                <el-col :span="24">
                    <h3>MBTI职业性格测试</h3>
                    <h6>
                        <span>
                        <img src="../../assets/images/people.png" alt="完成人数" />
                        {{ experienceList.test_use_count }}人已完成
                        </span>
                        <span style="margin-left: 20px">
                        <img src="../../assets/images/question.png" alt="完成人数" />
                        {{ experienceList.test_count }}道题
                        </span>
                    </h6>
                    <button @click="StartTest" :disabled="experienceList.user_count == 0 ? true : false">立即测试</button>
                    <button @click="gotoPerson" class="evaluation-card-btn">测试记录</button>
                    <h6 style="margin-top: 16px;">
                        本月还剩{{ experienceList.user_count }}次测试机会
                    </h6>
                </el-col>
            </el-row>
        </div>
        <el-row class="zy-school">
            <div class="evaluation-infor">
                <span class="evluation-infor-title-bg2"></span>
                <span class="evluation-infor-title-bg1"></span>
                <h3>测评介绍</h3>
            </div>
            <h3>你的性格，决定了你适合什么样的工作</h3>
            <img
                src="../../assets/images/character-img2.png"
                alt="兴趣测试"
                class="evluation-xingqu"
            />
            <p >
                常有人问，职场快速成长的秘诀是什么？
            </p>
            <p>
                这很难回答，但其中一个一定是：<span>选择，往往比努力更重要。</span> 
            </p>
            <p>大多数人找工作时，往往忽略了自己的性格是否与之匹配，在迷茫中选错赛道，最后变成<span>“不满意现在的工作，却又不知道自己究竟适合什么”</span>，5年、10年后，再没有从头再来的机会和勇气。</p>
            <p>事实上，找到自己的性格优势，走合适你的路，<span>不但能把个人潜能发挥到极致</span>，且工作本身，就能带给你愉悦感，<span>从而更容易取得更高的成就。</span></p>
            <p>那么，你的性格特点如何？跟别人比最大的优势在哪里？做哪种工作才最合适你？</p>
            <img
                src="../../assets/images/character-img1.png"
                alt="兴趣测试"
                class="evluation-xingqu"
            />
            <p class="evluation-infor-p">
                本次测评从<span>动力、信息收集、决策方式、生活方式4个</span>关键要素，将人的个性划分为16种职业性格类型，并从<span>职业性格、职业倾向</span>两方面，评估你的<span>性格优势和劣势</span>，推荐最适合你的工作岗位，并且给出发展建议。
            </p>
        </el-row>
        <el-row class="evaluation-detail-drawer" v-if="openTest">
            <el-row class="drawer-box" v-if="showQuestion">
                <el-row class="drawer-box-top">
                <el-col :span="12" class="drawer-title">MBTI职业性格测试</el-col>
                <el-col :span="12">
                    <button @click="hiddenQuestion">退出</button>
                    <button class="drawer-btn" @click="showLoading">提交</button>
                </el-col>
                </el-row>
                <el-row class="drawer-count">
                <span class="drawer-span">{{ current_question.num }}</span>
                <span>/{{ question_list.length }}</span>
                </el-row>
                <el-row class="drawer-question">
                <h6>{{ current_question.question_name }}</h6>
                <el-row
                    class="drawer-select"
                    v-for="(item, index) in current_question.answers"
                    :key="index"
                    :class="
                    selectIndex === index || item.checked ? 'select-answer' : ''
                    "
                    @click.native="selectAnswer(index, item,current_question.num, current_question.question_id)"
                >
                    <el-col :span="2">{{ String.fromCharCode(65 + index) }}</el-col>
                    <el-col :span="20">{{ item.answer_name }}</el-col>
                    <el-col :span="2">
                    <img
                        src="../../assets/images/right.png"
                        alt="选中"
                        v-if="selectIndex === index || item.checked"
                    />
                    </el-col>
                </el-row>
                </el-row>
                <el-row class="drawer-question-btn">
                <button
                    :class="{ 'drawer-btn-prev': current_question.num === 1 }"
                    @click="last_question"
                >
                    上一题
                </button>
                <button
                    class="drawer-btn-next"
                    :class="{
                    'drawer-btn-prev': current_question.num === question_list.length,
                    }"
                    @click="choice_answer(current_question.num)"
                >
                    下一题
                </button>
                </el-row>
                <el-row class="drawer-question-loading" v-if="showLoad">
                <img src="../../assets/images/loading.png" alt="结果生成中" />
                <h6>正在生成结果</h6>
                </el-row>
            </el-row>
            <!-- <EvaluationResult
                ref="evaluation_result"
                v-if="showResult"
                :now_date="now_date"
                :typeIndex="typeIndex"
                :holland_result="holland_result"
                @closeResult="closeResult"
            ></EvaluationResult> -->
        </el-row>
    </div>
</template>

<script>
import { getEvaluationTimes } from "@/api/home";
import { getHistoryRecordDetail } from "@/api/user";
import { mapState } from "vuex";
// import EvaluationResult from "@/components/EvaluationResult";
import {
    // getEvaluationDetail,
    getQuestionList,
    getResult
} from "@/api/evaluation";
import { nowTime } from '@/utils/auth'
export default {
    // components: { EvaluationResult },
    data() {
        return {
            experienceList: [],
            openTest: false,
            showLoad: false,
            // showResult: false,
            question_list: [],
            showQuestion: false,
            current_question: {},
            answer_jsons: {},
            check_answer_obj: {},
            selectIndex: -1,
            holland_result: {},
            now_date: '',
            has_code: 0
            // typeIndex:1,
        };
    },
    computed: {
        ...mapState({
            token: (state) => state.user.token,
            isShowVip: state => state.user.isShowVip,
            isVipStr: state => state.user.isVipStr,
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        token (newVal) {
            if(newVal != '') {
                this.getEvaluationTimes();
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00008'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        if(!this.$store.state.user.token) {
            this.$store.commit('user/LOGINSTATUS', true);
            return
        }
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00008'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        this.getEvaluationTimes();
    },
    methods: {
        getEvaluationTimes() {
            getEvaluationTimes().then((res) => {
                let experienceList = [];
                res.data.map((item) => {
                    experienceList[item.test_id - 1] = item;
                });
                this.experienceList = {...experienceList[1]};
            });
        },
        // getEvaluationDetail() {
        //     getEvaluationDetail(this.typeIndex + 1).then((res) => {
        //         this.evaType[this.typeIndex] = {
        //         ...this.evaType[this.typeIndex],
        //         question_counts: res.data.question_counts,
        //         };
        //         this.$forceUpdate();
        //     });
        // },
        hiddenQuestion() {
            this.openTest = false;
            this.showQuestion = false;
            // this.showResult = false;
        },
        showLoading() {
            if (
                Object.getOwnPropertyNames(this.answer_jsons).length - 1 !==
                this.question_list.length
            ) {
                this.$message({
                message: "请将题目全部完成后再提交",
                type: "error",
                });
                return false;
            }
            this.showLoad = true;
            const answer_jsons = [];
            for (const i in this.answer_jsons) {
                for (const j in this.answer_jsons[i]) {
                    const answers_tmp = [];
                    answers_tmp[0] = i;
                    answers_tmp[1] = j;
                    answer_jsons.push(answers_tmp);
                }
            }
            getResult(this.experienceList.test_id, answer_jsons, this.now_date).then((res) => {
                this.showLoad = false;
                this.showQuestion = false;
                this.openTest = false;
                if(res.status != '200') {
                    return
                }
                const url = getHistoryRecordDetail(res.data);
                window.open(url)
                this.getEvaluationTimes();
            });
        },
        // closeResult() {
        //     this.openTest = false;
        //     this.showResult = false;
        // },
        StartTest() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            getQuestionList(this.experienceList.test_id).then((res) => {
                this.now_date = nowTime();
                this.openTest = true;
                this.showQuestion = true;
                this.question_list = res.data.question;
                this.question_list.forEach((item, index) => {
                item.num = index + 1;
                });
                this.current_question = this.question_list[0];
                this.answer_jsons = {};
            });
        },
        gotoPerson() {
            this.$router.push({
                path: "/person",
                query: {
                    type: 'test'
                }
            });
        },
        selectAnswer(index, obj, num, question_id) {
            this.current_question.answers.forEach((item) => {
                item.checked = false;
            });
            this.selectIndex = index;
            this.check_answer_obj = obj;
            this.answer_jsons[question_id] = {};
            this.answer_jsons[question_id][
                this.check_answer_obj.answer_id
            ] = this.check_answer_obj.answer_name;
            this.question_list[this.current_question.num - 1].answers[
                this.selectIndex
            ].checked = true;
            setTimeout(()=>{
                this.selectIndex = -1;
                if (num < this.question_list.length) {
                    this.current_question = this.question_list[num];
                }
            },200)
        },
        last_question() {
            if (this.current_question.num > 1) {
                this.selectIndex = -1;
                this.current_question =
                this.question_list[this.current_question.num - 2];
            }
        },
        choice_answer(num) {
            let answer = this.question_list[this.current_question.num - 1].answers;
            let findIndex = answer.findIndex(item1 => item1.checked == true);
            if(findIndex == -1) {
                this.$message({
                    message: '请选择答案',
                    type: 'error'
                })
                return
            }
            this.selectIndex = -1;
            if (num < this.question_list.length) {
                this.current_question = this.question_list[num];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    button {
        outline: none;
    }
    .evaluation-box-content {
        background: #ffffff;
    }
    .evaluation-bg {
        background: url("../../assets/images/zncp-bg1.jpg") no-repeat;
        background-position: center;
        background-size: cover;
        height: 438px;
        box-sizing: border-box;
        position: relative;
        .breadcrumb-box {
            margin-top: 0 !important;
        }
    }
    .zy-school {
        @include gwidth;
        margin-top: 68px;
        .evaluation-infor {
            h3 {
                font-size: 26px;
                color: #ffffff;
                font-weight: 600;
                margin: 0 auto;
                position: relative;
                z-index: 99;
                padding: 0 18px;
                line-height: 44px;
            }
            .evluation-infor-title-bg1 {
                transform: skew(-10deg); /*设置倾斜度为-30*/
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 140px;
                height: 44px;
                background: $common-color;
                border-radius: 8px;
                position: absolute;
                left: 4px;
                top: 0px;
            }
            .evluation-infor-title-bg2 {
                transform: skew(-10deg); /*设置倾斜度为-30*/
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 140px;
                height: 44px;
                background: #ffd624;
                border-radius: 8px;
                position: absolute;
                top: 4px;
                left: 0px;
            }
        }
        > h3 {
            color: #332e2c;
            font-weight: 600;
            font-size: 26px;
            text-align: center;
            margin: 40px 0 0 0;
        }
        .evluation-infor-p{
            margin-top: 0!important;
        }
        p {
            font-size: 20px;
            font-weight: 400;
            color: #332e2c;
            line-height: 36px;
            margin: 0;
            margin-top: 32px;
            span {
                color: $common-color;
            }
        }
        .evluation-xingqu {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin: 48px 0;
        }
    }
    .zyb-box {
        background: none;
        border-radius: 0;
        box-shadow: none;
        position: relative;
        top: 0px;
    }
    .evaluation-bg {
        .evaluation-card {
            @include gwidth;
            position: absolute;
            margin-top: 46px;
            left: 50%;
            transform: translateX(-50%);
        }
        .evaluation-img1 {
            width: 200px;
            height: 200px;
            position: relative;
            bottom: 28px;
            right: 28px;
        }
        h3 {
            font-size: 70px;
            color: #ffffff;
            font-weight: 400;
            margin: 0;
            font-family: 'zihun443hao';
            line-height: 101px;
        }
        h6 {
            font-size: 12px;
            color: #ffffff;
            font-weight: 400;
            margin: 0;
            margin-top: 34px;
            img {
                width: 14px;
                height: 14px;
                position: relative;
                top: 3px;
            }
        }
        button {
            border: none;
            font-size: 16px;
            color: $common-color;
            width: 136px;
            height: 50px;
            background: #ffffff!important;
            border: 1px solid #ffffff!important;
            border-radius: 8px;
            margin-top: 56px;
            font-size: 18px;
            margin-right: 24px;
        }
        .evaluation-card-btn {
            background: rgba(255,255,255,0.20)!important;
            border: 1px solid #ffffff!important;
            border-radius: 8px;
            color: #ffffff;
        }
    }
    .evaluation-detail-drawer{
        background: rgba(0, 0, 0, 0.4);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        padding: 160px 0;
        overflow-y: scroll;
    }
    .drawer-box {
        width: 684px;
        margin-top: 160px;
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(51, 55, 61, 0.2);
        position: relative;
        left: 50%;
        border-radius: 10px;
        transform: translateX(-50%);
        border-radius: 10px;
        padding: 32px 40px;
        position: relative;
    }
    .drawer-box-top {
        .drawer-title {
            color: #2c2e33;
            font-weight: 600;
            font-size: 28px;
        }
        .el-col-12:last-child {
            text-align: right;
        }
        button {
            width: 76px;
            height: 44px;
            background: #ffffff;
            border: 1px solid #c4c7cc;
            border-radius: 8px;
            color: #5e6166;
            font-weight: 400;
            margin-left: 16px;
            font-size: 16px;
        }
        .drawer-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c);;
            color: #ffffff;
            border: 1px solid transparent;
        }
    }
    .drawer-count {
        margin-top: 24px;
        span {
            color: #909399;
            font-size: 18px;
            font-weight: 500;
        }
        .drawer-span {
            color: $common-color;
            font-size: 28px;
        }
    }
    .drawer-question {
        h6 {
            color: #2c2e33;
            font-size: 20px;
            font-weight: 500;
            margin-top: 16px;
            margin-bottom: 144px;
        }
    }
    .drawer-select {
        height: 48px;
        background: #ffffff;
        border: 1px solid #c4c7cc;
        border-radius: 10px;
        line-height: 48px;
        color: #5e6166;
        font-size: 18px;
        padding: 0 16px 0 24px;
        margin-bottom: 16px;
        cursor: pointer;
        .el-col-2:last-child {
            text-align: right;
        }
        img {
            width: 23px;
            height: 18px;
        }
    }
    .select-answer {
        border: 1px solid $common-color;
        color: $common-color;
    }
    .drawer-question-btn {
        margin-top: 20px;
        button {
            width: 240px;
            height: 52px;
            background: none;
            border: none;
            border-radius: 8px;
            background: #ffffff;
            border: 1px solid #c4c7cc;
        }
        .drawer-btn-prev {
            background: #f0f2f5 !important;
            border: 1px solid transparent;
            color: #909399;
        }
        .drawer-btn-next {
            position: absolute;
            right: 0;
        }
    }
    .drawer-question-loading {
        width: 132px;
        height: 104px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 6px;
        text-align: center;
        padding-top: 14px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
        img {
            width: 48px;
            height: 48px;
            -webkit-transform: rotate(360deg);
            animation: rotation 1s linear infinite;
            -moz-animation: rotation 1s linear infinite;
            -webkit-animation: rotation 1s linear infinite;
            -o-animation: rotation 1s linear infinite;
        }
        h6 {
            color: #ffffff;
            font-size: 14px;
            font-weight: 400;
            margin-top: 10px;
        }
    @-webkit-keyframes rotation {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
        }
    }
    .result-box {
        width: 684px;
        background: #ffffff;
        border-radius: 10px;
        box-shadow: 0px 1px 6px 0px rgba(51, 55, 61, 0.2);
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        background: $common-color;
        .result-title {
            height: 106px;
            background: #ffffff;
            border-radius: 10px 10px 0 0;
            padding: 0 40px;
            h4 {
            color: #2c2e33;
            font-size: 28px;
            font-weight: 600;
            margin: 32px 0 8px 0;
            }
            h6 {
            color: #5e6166;
            font-weight: 400;
            font-size: 14px;
            margin: 0;
            }
            .el-col-2 {
            text-align: right;
            img {
                width: 24px;
                height: 24px;
                margin-top: 40px;
                cursor: pointer;
            }
            }
        }
        .result-content {
            padding: 22px 56px 38px 56px;
            .result-content-sm {
            width: 123px;
            text-align: center;
            height: 34px;
            background: linear-gradient(133deg, #ffce5d 1%, #ffa02f 97%, #ffa02f 97%);
            border-radius: 6px 0px 18px 0px;
            color: #ffffff;
            font-size: 16px;
            font-weight: 400;
            line-height: 34px;
            }
            p {
            color: #5e6166;
            font-size: 14px;
            margin: 8px 16px;
            line-height: 22px;
            letter-spacing: 1px;
            }
            .result-content-card {
            margin-top: 16px;
            padding: 13px 16px 52px 16px;
            .result-content-img {
                text-align: center;
            }
            img {
                width: 170px;
                height: 170px;
                margin: 0 auto;
            }
            h4 {
                color: #5e6166;
                font-weight: 600;
                font-size: 18px;
                margin: 13px 0 8px 0;
            }
            h3 {
                font-weight: 600;
                font-size: 28px;
                color: $common-color;
                margin-left: 5px;
                margin-bottom: 16px;
            }
            h5 {
                font-size: 18px;
                color: #2c2e33;
                font-weight: 600;
                margin-top: 24px;
            }
            p {
                color: #5e6166;
                font-size: 14px;
                font-weight: 400;
                text-align: left;
                border-top: 1px solid #f0f2f5;
                padding-top: 16px;
                margin: 0;
            }
            .result-content-line {
                width: 180px;
                height: 13px;
                background: #dcecff;
                border-radius: 1px;
                margin: 0 auto;
                margin-top: -40px;
            }
            .result-content-grade,
            h6 {
                text-align: left;
                margin-top: 17px;
                color: #5e6166;
                font-size: 12px;
                font-weight: 400;
            }
            span {
                display: inline-block;
            }
            .result-content-jx {
                width: 26px;
                height: 16px;
                background: rgba(50, 114, 255, 0.12);
                border: 1px solid $common-color;
                border-radius: 2px;
                position: relative;
                top: 3px;
                margin-right: 6px;
            }
            h6 {
                text-align: center;
                margin: 0;
            }
            .result-content-part-diff1 {
                .result-content-jx {
                border: 1px solid #fff;
                background: linear-gradient(180deg, #a8eeff, $common-color);
                }
                .result-content-line {
                width: 150px;
                }
                h4 {
                color: #2c2e33;
                font-size: 16px;
                font-weight: 600;
                text-align: left;
                margin-top: 24px;
                }
                h4:first-child {
                margin-bottom: 24px;
                }
                p {
                font-size: 14px;
                font-weight: 400;
                color: #2c2e33;
                border: none !important;
                }
            }
            .result-content-part-diff2 {
                .result-content-line {
                width: 90px;
                }
                p {
                font-size: 14px;
                font-weight: 400;
                color: #2c2e33;
                border: none !important;
                padding-top: 24px;
                }
            }
            }
            .result-content-card-diff {
            .result-content-part-common {
                margin-top: 16px;
            }
            .result-content-h4 {
                color: #2c2e33;
                font-size: 16px;
                font-weight: bold;
                margin-top: 29px;
                text-align: left;
                padding-top: 12px;
                border-top: 1px solid #f0f2f5;
            }
            h6 {
                padding: 0 20%;
                text-align: left !important;
            }
            .result-content-part-diff1 {
                h4 {
                margin-top: 16px !important;
                margin-bottom: 0 !important;
                font-weight: 500 !important;
                }
                h4:first-child {
                margin-top: 20px !important;
                }
                p {
                padding: 0 !important;
                }
            }
            .result-content-part-diff2 {
                .result-content-line {
                width: 116px !important;
                }
                h3 {
                font-size: 20px !important;
                font-weight: 600;
                color: $common-color;
                margin-top: 23px !important;
                }
                span {
                color: #2c2e33 !important;
                font-weight: 500 !important;
                font-size: 14px !important;
                }
            }
            .result-content-part-diff3 {
                .result-content-line {
                width: 150px;
                margin-bottom: 20px;
                }
                p {
                padding: 0 !important;
                border: none !important;
                }
            }
            .result-content-part-diff4 {
                .result-content-line {
                width: 204px;
                }
            }
            .result-content-part-diff5 {
                .result-content-line {
                width: 260px;
                }
            }
            .result-content-part-diff6 {
                .result-content-line {
                width: 80px;
                margin-bottom: 16px;
                }
            }
            .result-content-part-diff7 {
                .result-content-line {
                width: 110px;
                margin-bottom: 16px;
                }
            }
            }
        }
    }
</style>